// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2vY5A","list":"PatternAutocomplete_list__137iI"};